import { useQuery } from 'react-query';
import eventLogService, { EventLogClinicSummary } from '../services/eventLog.service';

const useEventLogClinicSummary = (clinicId: number, startDate?: string, endDate?: string) => {
  const { status, data, error, isFetching, refetch } = useQuery<EventLogClinicSummary>(
    ['eventLogClinicSummary', clinicId, startDate, endDate],
    () => eventLogService.getClinicSummary(clinicId, { startDate, endDate }),
    {
      refetchOnWindowFocus: false,
      enabled: !!clinicId,
    }
  );

  return {
    status,
    data,
    error,
    isFetching,
    refetch,
  };
};

export default useEventLogClinicSummary;
